











































































import editPowerOfAttorneyDialog from '@/components/client/view-client/edit-power-of-attorney-dialog.vue';
import { ClientAccount } from '@/shared/clients/client-account';
import { ClientPowerOfAttorney } from '@/shared/clients/client-power-of-attorney';
import { PowerOfAttorneyType } from '@/shared/types/power-of-attorney-type';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const typesModule = namespace('types');
const userModule = namespace('user');

@Component({
    components: {
        editPowerOfAttorneyDialog,
    },
})
export default class PowerOfAttorneys extends Vue {
    @typesModule.Getter('powerOfAttorneyTypes') private powerOfAttorneyTypes!: Array<PowerOfAttorneyType>;
    @userModule.Getter('isAdministrator') private isAdministrator!: boolean;

    @Prop({ required: true }) private client!: ClientAccount;

    private selectedPowerOfAttorney: ClientPowerOfAttorney | null = null;
    private editPowerOfAttorneyDialogVisible: boolean = false;
    private deletePowerOfAttorneyConfirmationDialogVisible: boolean = false;

    private get powerOfAttorneyFields(): Array<{}> {
        return [
            { key: 'type', label: 'Type' },
            { key: 'ppReference', label: 'PP Reference' },
            { key: 'rightLegalReference', label: 'Right Legal Reference' },
            { key: 'attorney1', label: 'Attorney 1' },
            { key: 'attorney2', label: 'Attorney 2' },
            { key: 'attorney3', label: 'Attorney 3' },
            { key: 'attorney4', label: 'Attorney 4' },
            { key: 'signatureDate', label: 'Signature Date' },
            { key: 'isRegistered', label: 'Registered?', class: 'text-center' },
            { key: 'hasChoicesIWouldMake', label: 'Choices I Would Make?', class: 'text-center' },
            { key: 'actions', label: '', class: 'col-1', tdClass: 'text-right' },
        ];
    }

    private powerOfAttorneyTypeVariant(id: string | null): string {
        if (id == null) {
            return 'secondary';
        }

        const powerOfAttorneyType = this.powerOfAttorneyTypes.find((type) => type.id === id);
        return powerOfAttorneyType == null || powerOfAttorneyType.isUnknown ? 'secondary' : 'primary';
    }

    private powerOfAttorneyTypeDescription(id: string | null): string {
        if (id == null) {
            return '';
        }

        const powerOfAttorneyType = this.powerOfAttorneyTypes.find((type) => type.id === id);
        return powerOfAttorneyType == null ? '' : powerOfAttorneyType.value;
    }

    private showEditPowerOfAttorneyDialog(powerOfAttorney: ClientPowerOfAttorney): void {
        if (powerOfAttorney.id == null) {
            powerOfAttorney.id = 'editing';
        }

        this.selectedPowerOfAttorney = { ...powerOfAttorney };
        this.editPowerOfAttorneyDialogVisible = true;
    }

    private showDeletePowerOfAttorneyDialog(powerOfAttorney: ClientPowerOfAttorney): void {
        if (powerOfAttorney.id == null) {
            powerOfAttorney.id = 'editing';
        }

        this.selectedPowerOfAttorney = { ...powerOfAttorney };
        this.deletePowerOfAttorneyConfirmationDialogVisible = true;
    }

    private onPowerOfAttorneyUpdated(powerOfAttorney: ClientPowerOfAttorney): void {
        const index = this.client!.powerOfAttorneys.findIndex((poa) => poa.id === powerOfAttorney.id);

        if (index < 0) {
            return;
        }

        if (powerOfAttorney.id === 'editing') {
            powerOfAttorney.id = null;
        }

        this.client!.powerOfAttorneys.splice(index, 1, powerOfAttorney);
        this.onCancel();
    }

    private onPowerOfAttorneyDeleted(): void {
        const index = this.client!.powerOfAttorneys.findIndex((poa) => poa.id === this.selectedPowerOfAttorney!.id);

        if (index < 0) {
            return;
        }

        if (this.selectedPowerOfAttorney!.id === 'editing') {
            this.selectedPowerOfAttorney!.id = null;
        }

        this.client!.powerOfAttorneys.splice(index, 1);
        this.onCancel();
    }

    private onCancel(): void {
        for (const powerOfAttorney of this.client!.powerOfAttorneys.filter((poa) => poa.id === 'editing')) {
            powerOfAttorney.id = null;
        }

        this.selectedPowerOfAttorney = null;
        this.editPowerOfAttorneyDialogVisible = false;
        this.deletePowerOfAttorneyConfirmationDialogVisible = false;
    }
}
